import React, { useState } from "react"
import { useEffect } from "react"

import styles from "./DeliveryTimeSlotForm.module.scss"
import formattedPrice from "../shared/formatted_price";

const DATE_SLOTS = "date_slots"
const TIME_SLOTS = "time_slots"

function DeliveryTimeSlotForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { slots, index, onChange, errors } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [dateIndex, setDateIndex] = useState(null)

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    if (dateIndex === null) return
    // reset time slot
    onChange(undefined)
  }, [dateIndex])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function uniqueElements(array) {
    return array.filter(function (value, index, self) {
      return self.indexOf(value) === index
    })
  }

  function renderErrors(errors) {
    if (!errors.time_slot) return null

    return errors.time_slot.map((error, index) => {
      return (
        <div key={index} className="help-block error">
          {error}
        </div>
      )
    })
  }

  function renderTimeOptions(slots) {
    const showPrice = uniqueElements(slots.map((slot) => slot.vehicle_type)).length !== 1

    return slots
      .filter((slot) => slot.date === dates[dateIndex || 0])
      .map((slot) => {
        const { start_time, end_time, index } = slot
        let text = `${start_time}-${end_time}`

        if (showPrice) {
          const { price_cents, vehicle_type } = slot
          const vehicle_name = I18n.t(
            `cart_summary.vehicle_types.${vehicle_type}`
          )
          const price = formattedPrice(price_cents)
          text = `${start_time}-${end_time} (${price} ${vehicle_name})`
        }

        return (
          <option key={index} value={index ?? undefined}>
            {text}
          </option>
        )
      })
  }

  function renderTimeSlotsSelector() {
    return (
      <div className={`${hasOnlyToday ? "col-sm-12" : "col-sm-6" }`}>
        <div className="form-group">
          <select
            name={TIME_SLOTS}
            className="form-control"
            value={index || undefined}
            onChange={(event) => onChange(event.target.value)}
          >
            <option value={undefined}>
              {I18n.t("cart_summary.select_delivery_time")}
            </option>
            {renderTimeOptions(indexedSlots)}
          </select>
          <i className={`fal fa-angle-down ${styles.arrowIcon}`} />
        </div>
      </div>
    )
  }

  function renderDatesSelector() {
    return (
      <div className="col-sm-6">
        <div className="form-group">
          <select
            name={DATE_SLOTS}
            className="form-control"
            value={dateIndex || 0}
            onChange={(event) => setDateIndex(event.target.value)}
          >
            {dates.map((date, index) => {
              let jsDate = new Date(date)
              let text = jsDate.toLocaleString(I18n.locale, {
                day: "2-digit",
                month: "long",
              })
              if (jsDate.getDate() === new Date().getDate()) {
                text = `${I18n.t("today")}, ${text}`
              }
              return (
                <option key={index} value={index}>
                  {text}
                </option>
              )
            })}
          </select>
          <i className={`fal fa-angle-down ${styles.arrowIcon}`} />
        </div>
      </div>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let indexedSlots = slots.map((slot, index) => ({ ...slot, index: index }))

  let hasOnlyToday = true

  const today = new Date().getDate()
  const datesSet = new Set(
    slots.map((slot) => {
      let jsDate = slot.date && new Date(slot.date)
      if (today !== jsDate?.getDate()) {
        hasOnlyToday = false
      }
      return slot.date
    })
  )
  let dates = [...datesSet]

  // -------------------------------------

  return (
    <div className="delivery-address-form order-step">
      <h4>{I18n.t("cart_summary.delivery_time")}</h4>
      <p className="checkout-info">
        {I18n.t("cart_summary.delivery_time_desc")}
      </p>
      <fieldset>
        <div className="row">
          {!hasOnlyToday && renderDatesSelector()}
          {renderTimeSlotsSelector()}
        </div>
        <div className="row">{renderErrors(errors)}</div>
      </fieldset>
    </div>
  )
}

export default DeliveryTimeSlotForm
